export default __webpack_public_path__ + "static/media/cuciVoucher2.23bb793b.png";